import Light from './Light'

export const BarinetLight = Light
export const BarinetDark = Light
